// https://api.open-meteo.com/v1/forecast?latitude=55.6759&longitude=12.5655&current=wind_speed_10m,wind_direction_10m,wind_gusts_10m&hourly=wind_speed_10m,wind_direction_10m,wind_gusts_10m&daily=wind_speed_10m_max,wind_gusts_10m_max,wind_direction_10m_dominant&timezone=auto&past_days=7&forecast_days=1

import { radianToDegree } from 'ixfx/geometry';
import cannedData from './test.json';
import { GeoLocation, WindDataPoint } from './types';
import * as Units from './units';


export type ApiDataPoint = {
  interval: number
  time: string
  wind_direction_10m: number
  wind_gusts_10m: number
  wind_speed_10m: number
}

export type ApiDataPoints = {
  time: string[]
  wind_direction_10m_dominant: number[]
  wind_gusts_10m_max: number[]
  wind_speed_10m_max: number[]
}

export type ApiUnits =
  {
    time: string
    wind_direction_10m_dominant: string
    wind_gusts_10m_max: string
    wind_speed_10m_max: string

  }
export type ApiDataResponseDaily = {
  daily: {
    time: string[]
    wind_direction_10m_dominant: number[]
    wind_gusts_10m_max: number[]
    wind_speed_10m_max: number[]
  },
  daily_units: ApiUnits,
}

export type ApiDataResponseHourly = {
  hourly: {
    time: string[]
    wind_direction_10m: number[]
    wind_gusts_10m: number[]
    wind_speed_10m: number[]
  },
  hourly_units: {
    time: string
    wind_direction_10m: string
    wind_gusts_10m: string
    wind_speed_10m: string
  },
}

export type ApiDataResponse = {
  current: ApiDataPoint
  current_units: ApiDataPoint
  elevation: number
  generationtime_ms: number
  latitude: number
  longitude: number
  timezone: string
  timezone_abbreviation: string
  utc_offset_seconds: number
} & Partial<ApiDataResponseHourly>

export async function fetchData(location: GeoLocation): Promise<ApiDataResponse> {
  const url = `https://api.open-meteo.com/v1/forecast?latitude=${ location.latitude }&longitude=${ location.longitude }&current=wind_speed_10m,wind_direction_10m,wind_gusts_10m&hourly=wind_speed_10m,wind_direction_10m,wind_gusts_10m&timezone=auto&past_days=7&forecast_days=1`
  //throw new Error(`disabled`);
  const resp = await fetch(url);
  return await resp.json() as ApiDataResponse;
}

export function fetchFallbackData() {
  return cannedData as ApiDataResponse;
}

export function processData(d: ApiDataResponse) {
  const hourly = d.hourly;
  const hourlyUnits = d.hourly_units;
  if (!hourly || !hourlyUnits) {
    console.warn(`Hourly data missing`);
    return []
  }
  const count = hourly.time.length;
  const hourlyData: WindDataPoint[] = [];
  for (let i = 0; i < count; i++) {
    const w: WindDataPoint = {
      direction: Units.toRadians(hourly.wind_direction_10m[ i ], hourlyUnits.wind_direction_10m),
      gusts: Units.toMetersPerSec(hourly.wind_gusts_10m[ i ], hourlyUnits.wind_gusts_10m),
      speed: Units.toMetersPerSec(hourly.wind_speed_10m[ i ], hourlyUnits.wind_speed_10m),
      time: Date.parse(hourly.time[ i ]),
      height: 10,
      interval: 60
    }
    hourlyData.push(w);
  }
  return hourlyData;
}